import React, { useMemo } from "react";
import { IPerson } from "../../models/IPerson";
import { PopupProps, List, Icon, Divider } from "semantic-ui-react";
import { ImageView } from "@sg-fileupload/components/Image";
import { SemanticICONS } from "semantic-ui-react/dist/commonjs/generic";
import CompanyName from "../companies/CompanyName";
import { PersonCertStatus } from "./PersonCertStatus";
import { getPersonCertStatus } from "../../utils/cert.helper";
import { IPersonCert } from "../../models/IPersonCert";
import { ICompany } from "../../models/ICompany";

interface PersonPopupContentProps extends PopupProps {
    person: IPerson;
    company: ICompany | null;
    showCompany?: boolean;
    showPhone?: boolean;

};

export const PersonPopupContent: React.FC<PersonPopupContentProps> = ({ person, company }) => {

    const renderField = (icon: SemanticICONS | JSX.Element, content: any) => (
        <List.Item>
            <List.Icon>
                {typeof icon === "string" ? <Icon name={icon} /> : icon}

            </List.Icon>
            <List.Content> {content} </List.Content>
        </List.Item>
    );

    const renderCert = (cert: IPersonCert) => {
        const status = getPersonCertStatus(cert, true);
        const icon = <PersonCertStatus status={status} />;
        return (
            renderField(icon, cert?.name)
        )
    }

    const certs = useMemo(() => {
        const certs = person.certs;
        if (certs) {
            return Object.keys(certs).reduce<Array<IPersonCert>>((acc, key) => {
                const cert = certs[key];
                return cert ? acc.concat(cert) : acc
            }, [])
        };
        return []
    }, [person.certs]);


    return (
        <div style={{ minWidth: '300px' }}>
            <div style={{ display: 'flex', alignItems: 'end', marginBottom: "-5px" }}>
                <span style={{ marginLeft: '5px' }}>
                    <h5>
                        {person.image ? <ImageView id={person.image} avatar /> : null}
                        {person.fullname}
                    </h5>
                </span>
            </div>
            <List>
                {person.phone && renderField("phone", person.phone)}
                {person.email && renderField("envelope", person.email)}
                {person.company && company && renderField("building", <CompanyName company={company} />)}

                <Divider hidden />

                {certs.map(renderCert)}

            </List>
        </div>
    );
};
